import React from "react";
import useGrantAccess from "./hook";
import Modal from "../../Components/Modal/Modal";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import Spinner from "../../Components/Spinner/Spinner";

const GrantAccessPageLayout = ({
  loading,
  isOpenModal,
  handleSubmitUpdateRequestCalendar,
}) => {
  return (
    <div className="flex h-screen flex-col items-center justify-center">
      {loading && <Spinner small />}
    </div>
  );
};

const GrantAccessPage = (props) => {
  return <GrantAccessPageLayout {...useGrantAccess(props)} />;
};

export default GrantAccessPage;
